export default __webpack_public_path__ + "static/media/arrow.c76f0cf2.svg";